import { UrlConstants } from "../url.constants";
export class ApiWayleaveConstants {
    static URL = UrlConstants.API_V2 + "Wayleave";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetWayleaveApplicantAndApplicantAgent";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateWayleaveInvoiceReport";
    static FUNCTION_SET_PROFESSIONAL_BODIES = "SetWayleaveProfessionalBodies";
    static FUNCTION_GET_WAYLEAVE_APPLICATIONS_BY_USER = "GetWApplicationsByUser";
    static FUNCTION_SET_LOCATION = "SetWayleaveLocation";
    static FUNCTION_GET_MY_AFLA_PORTAL_WAYLEAVE_APPLICATIONS = "GetMyAFLAPortalWayleaveApplications";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalWayleaveApplication";
}
